import React, { ReactNode } from 'react';
import { IKanbanBoardDataSourceItem } from 'common/models/commonModel';

interface IComponentProps<T> {
  dataSource: IKanbanBoardDataSourceItem<T>[];
  renderCard: (item: T, index: number) => ReactNode;
}

export function KanbanBoard<T>({ dataSource, renderCard }: IComponentProps<T>) {
  return (
    <div className="kanban-board" style={{ ['--cols' as any]: dataSource.length }}>
      {dataSource.map((item) => {
        return (
          <div key={item.key} className="kanban-board__column">
            <div className="mb-5 kanban-board__column-header">
              <span className="ff-medium fs-xs">{item.title}</span>
              <div className="kanban-board__column-count">{item.items.length}</div>
            </div>

            <div className="kanban-board__column-body">
              {item.items.map(renderCard)}

              {!item.items.length && <span className="ff-regular fs-xxs color-gray-1">No orders yet</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
